// 今は使われていないが、featureFlagはいずれ必要になるので残しておく
import { AxiosResponse } from 'axios';

import { EnabledFeatureFlag } from '@/types/enabledFeatureFlag';
import { api } from '@/services/api/axios/instance';
export const enabledFeatureFlagsApi = {
  getDetail: async (name: string): Promise<EnabledFeatureFlag> => {
    const path = `enabled_feature_flags/${name}`;

    const response: AxiosResponse<EnabledFeatureFlag> = await api.get(path);

    return response.data;
  },
};
